import { ApolloError } from '@apollo/client';
import { get, toNumber } from 'lodash';
import { Logger } from 'pino';

export const logApolloError = (
  error: ApolloError,
  logger: Logger,
  name: string,
): void => {
  if (
    (get(error, 'networkError.statusCode') &&
      toNumber(get(error, 'networkError.statusCode')) < 500) ||
    !error.networkError
  ) {
    logger.warn({ error }, '%s error: %s', name, error.message);
  } else {
    logger.error({ error }, '%s error: %s', name, error.message);
  }
};
